import React from 'react'
import './index.less'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'

export default class extends React.Component {
  state = {
    status: false
  }

  constructor(props) {
    super(props)
  }

  // componentDidMount() {
  //   let { status } = this.props
  //   this.setState({
  //     status: status
  //   })
  // }

  // componentWillReceiveProps(e) {
  //   console.log(e)
  //   let { status } = e
  //   this.setState({
  //     status: status
  //   })
  // }

  close(status) {
    this.setState({
      status: status
    })
    if (status == false) {
      window.scroll(0, 0)
      this.props.setNav(2)
    }
  }

  render() {
    const { deviceModel, language, mac, os, platform, systemVersion, version, versionCode } = localstorage.get('getUserDeviceInfo')
    let { status, nobg, lang } = this.props
    return (
      <div className={`modalS ${!this.state.status && 'hide'} ${nobg && 'nobg'}`}>
        <div className={`box`}>
          <img className={`icon`} src="/img/app/service/success.png" />
          <div className={`title`}>{lang.thanks}</div>
          <div className={`content`}>{lang.thanksC}{version}{deviceModel}{systemVersion}</div>
          <div className={`sure`} onClick={() => { this.close(false) }}>{lang.sure}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/Modal/index.js